import * as React from "react";
import { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import { _get, _post } from "../Api";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { Button } from "@material-ui/core";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

const fetchData = (id) => {
  return _get("/nova/ta_merchant/" + id + "/timeblocks")
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      console.log(e);
    });
};

export default function TimeBlocks() {
  const [blocks, setBlocks] = React.useState(null);
  const taMerchantId = Number.parseInt(useParams().taMerchantId);

  useEffect(() => {
    function onChange() {
      fetchData(taMerchantId).then((data) => {
        if (data) setBlocks(data);
      });
    }

    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChange);
  }, [taMerchantId]);

  const handleNewVal = (value, index, orderType = null) => {
    let block = {};
    Object.assign(block, blocks[index]);
    if (orderType === "takeaway") {
      block.max_ta_orders.takeaway = value;
    } else if (orderType === "delivery") {
      block.max_ta_orders.delivery = value;
    } else {
      block.weight = value;
    }
    block.order_type = orderType;
    _post("/nova/ta_merchant/" + taMerchantId + "/timeblocks", block)
      .catch((e) => {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      })
      .then((response) => {
        blocks[index] = response.data;
        setBlocks([...blocks]);
      });
  };

  if (!blocks) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Paper variant={"outlined"} style={{ padding: 45 }}>
      <Typography variant="h4">Timeblocks - {cloudStore.merchant.name}</Typography>
      <Divider style={{ margin: 20 }} />

      <Typography variant="caption">
        Max weight per time block:{" "}
        {cloudStore.merchant && cloudStore.merchant.ta_merchants.length > 0
          ? cloudStore.merchant.ta_merchants[0].max_weight_per_time_block
          : 0}
      </Typography>
      <Grid spacing={3} container xs direction={"row"}>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Time block
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Status
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Close
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Reset
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Orders
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Adjust
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Takeaway orders
          </Typography>
        </Grid>
        <Grid xs item>
          <Typography variant="h6" align={"center"}>
            Delivery orders
          </Typography>
        </Grid>
      </Grid>
      <Divider variant="light" style={{ margin: 10 }} />

      {blocks.map((block, i) => {
        return (
          <Grid container direction={"row"} spacing={3} xs>
            <Grid item xs style={{ textAlign: "center" }}>
              {block.name}
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              <Typography>
                {cloudStore.merchant != null &&
                block.weight >= cloudStore.merchant.ta_merchants[0].max_weight_per_time_block
                  ? "Gesloten"
                  : "Open"}
              </Typography>
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              <Button
                variant={"outlined"}
                onClick={() => handleNewVal(cloudStore.merchant.ta_merchants[0].max_weight_per_time_block, i)}
              >
                Close
              </Button>
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              <Button variant={"outlined"} onClick={() => handleNewVal(0, i)}>
                Reset
              </Button>
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              {block.weight}
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              <TextField value={block.weight} type="number" onChange={(e) => handleNewVal(e.target.value, i)} />
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              {block.max_ta_orders && (
                <>
                  Max {block.max_ta_orders?.max_takeaway}
                  <TextField
                    value={block.max_ta_orders?.takeaway}
                    type="number"
                    onChange={(e) => handleNewVal(e.target.value, i, "takeaway")}
                  />
                </>
              )}
            </Grid>
            <Grid item xs style={{ textAlign: "center" }}>
              {block.max_ta_orders && (
                <>
                  Max {block.max_ta_orders?.max_delivery}
                  <TextField
                    value={block.max_ta_orders?.delivery}
                    type="number"
                    onChange={(e) => handleNewVal(e.target.value, i, "delivery")}
                  />
                </>
              )}
            </Grid>
          </Grid>
        );
      })}
    </Paper>
  );
}
